import styled from '@emotion/styled';

export const Centered = styled('div')<{ height?: number }>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${(p) => (p.height ? `${p.height}px` : 'auto')};
`;
